import { commonFilter } from './filter';

export default {
  pageName: 'URL Analysis',
  pageId: '25082',
  pagePath: '/opinion/AIAnalysisHub/URLAnalysis',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
    KeywordSearchType: {
      buttonId: '2508201',
    },
    // GPT_Type: {
    //   buttonId: '2508202',
    // },
    EditPrompt: {
      buttonId: '2508203',
    },
    TypeTAB: {
      buttonId: '2508204',
    },
    GPTRegenerate: {
      buttonId: '2508207',
    },
    GPTCopy: {
      buttonId: '2508208',
    },
    GPTFullScreen: {
      buttonId: '2508209',
    },
    GotoFeeds: {
      buttonId: '2508210',
    },
    ReviewTypeTAB: {
      buttonId: '2508212',
    },
    SentimentStatisticsTAB: {
      buttonId: '2508213',
    },
    GPT_Get_Btn: {
      buttonId: '2508226',
    },
    GPT_Confirm: {
      buttonId: '2508227',
    },
    GPT_Stop: {
      buttonId: '2508228',
    },
    GPT_Agent: {
      buttonId: '2508229',
    },
    SelectVideoSummary: {
      buttonId: '2508230',
    },
    SelectCommentSummary: {
      buttonId: '2508231',
    },
    GPT_Options: {
      buttonId: '2508232',
    },
    GenerateReport: {
      buttonId: '2508233',
    },
  },
  card: {
    ChartCard: {
      bar: {
        buttonId: '2508214',
      },
      line: {
        buttonId: '2508215',
      },
      pie: {
        buttonId: '2508216',
      },
      table: {
        buttonId: '2508217',
      },
      'sentiment-s-bar': {
        buttonId: '2508218',
      },
      'common-bar': {
        buttonId: '2508219',
      },
      stack_line: {
        buttonId: '2508220',
      },
      download: {
        buttonId: '2508221',
      },
    },
    GPT: {
      refresh: {
        buttonId: '2508222',
      },
      copy: {
        buttonId: '2508223',
      },
      fullscreen: {
        buttonId: '2508224',
      },
      save: {
        buttonId: '2508225',
      },
    },
  },
};
